import { useQuery } from '@tanstack/react-query';
import { useDateRange } from '../context/DateContext';
import { fetchCeoSummary } from '../services/ceoReportingService';
import { toRangeTimestamps } from '../utils/dashboardDateRange';

/**
 * Shared CEO period summary — same Salesforce definitions as the CEO KPI row.
 * React Query dedupes with CeoReportingDashboard (identical query key).
 */
export function useDashboardCeoSummary() {
  const { startDate, endDate } = useDateRange();
  const { startIso, endIso, rangeKey } = toRangeTimestamps(startDate, endDate);

  return useQuery({
    queryKey: ['ceoSummary', rangeKey],
    queryFn: () => fetchCeoSummary({ startDate: startIso, endDate: endIso }),
    enabled: !!(startDate && endDate),
    staleTime: 60_000,
  });
}
